import { TriangleAlert } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { getOpenTrackingDiagnosticCount } from '../../lib/api/trackingDiagnostics'

export const TRACKING_DIAGNOSTICS_CHANGED_EVENT = 'tracking-diagnostics-changed'

export const TrackingDiagnosticsAlert = () => {
  const [openCount, setOpenCount] = useState(0)

  const refresh = useCallback(async () => {
    try {
      setOpenCount(await getOpenTrackingDiagnosticCount())
    } catch (error) {
      console.warn('Could not refresh tracking diagnostics count', error)
    }
  }, [])

  useEffect(() => {
    const initialRefresh = window.setTimeout(() => void refresh(), 0)
    const interval = window.setInterval(() => void refresh(), 60_000)
    window.addEventListener(TRACKING_DIAGNOSTICS_CHANGED_EVENT, refresh)

    return () => {
      window.clearTimeout(initialRefresh)
      window.clearInterval(interval)
      window.removeEventListener(TRACKING_DIAGNOSTICS_CHANGED_EVENT, refresh)
    }
  }, [refresh])

  if (openCount === 0) {
    return null
  }

  return (
    <Link
      to="/system/tracking-diagnostics"
      className="flex items-center justify-between gap-4 border-t border-amber-300/70 bg-amber-50 px-6 py-2.5 text-amber-950 transition-colors hover:bg-amber-100 dark:border-amber-500/30 dark:bg-amber-950/40 dark:text-amber-100 dark:hover:bg-amber-950/60"
      aria-label={`${openCount} open mobile tracking ${openCount === 1 ? 'alert' : 'alerts'}`}
    >
      <span className="flex items-center gap-2 text-sm font-semibold">
        <TriangleAlert className="h-4 w-4" />
        Mobile tracking may have failed for {openCount} {openCount === 1 ? 'session' : 'sessions'}
      </span>
      <span className="text-xs font-bold uppercase tracking-wide">Investigate</span>
    </Link>
  )
}
